import { render, staticRenderFns } from "./RouteDashboard.vue?vue&type=template&id=b4632594&scoped=true&"
import script from "./RouteDashboard.vue?vue&type=script&lang=js&"
export * from "./RouteDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4632594",
  null
  
)

export default component.exports